import {useEffect, useState} from 'react'

/**
 * Observes window focus state
 * @returns Whether the window is currently focused
 */
export const useWindowFocus = () => {
  const [isFocused, setIsFocused] = useState<boolean>(
    typeof window !== 'undefined' && document?.hasFocus()
  )

  useEffect(() => {
    const onFocus = () => setIsFocused(true)
    const onBlur = () => setIsFocused(false)

    window.addEventListener('focus', onFocus)
    window.addEventListener('blur', onBlur)

    return () => {
      window.removeEventListener('focus', onFocus)
      window.removeEventListener('blur', onBlur)
    }
  }, [])

  return isFocused
}
